module.exports = __webpack_public_path__ + "static/media/cart.cd4c60a3.svg";